/* eslint-disable */
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';



export const SvgMinusProfile = ({ size }) => {
    return (<Svg width={size} height={size} viewBox="0 0 25 25">
    <G fill="none" fillRule="evenodd">
    <Rect width="25" height="25" fill="#E8E8E8" rx="5"/>
    <Rect width="2" height="19" x="11.5" y="3" fill="#AEAEAE" transform="rotate(90 12.5 12.5)" rx="1"/>
  </G>
    </Svg>)
}

